<template lang="pug">
.navbar.px-2(v-if="usuario")
  section.navbar-section.d-flex.align-center
    a.mb-1.mr-2.c-hand.text-primary.flex-centered(
      @click="$router.back()",
      v-if="$route.name !== 'app.home'",
      data-tooltip="Voltar"
    )
      i.fa.fa-angle-left.fa-2x
      span.ml-1.mr-1 Voltar
    router-link.navbar-brand.text-primary(:to="{ name: 'app.home' }")
      img.img-logo(src="@/assets/logo-100.png", alt="Home")
  section.navbar-section
    .dropdown
      a.dropdown-toggle.c-hand(tabindex="0")
        span.mr-1
          figure.avatar(
            :data-initial="usuario.nome[0]",
            :class="{ 'bg-gray': usuario.url_thumb }"
          )
            img(:src="usuario.url_thumb", v-if="usuario.url_thumb")
        span
          span {{ usuario.nome }}
          i.fa.fa-caret-down.pl-2
      ul.menu
        li.menu-item(v-for="item in items", :id="item.id", :key="item.label")
          a.c-hand.p-relative(@click="item.action")
            .d-flex.centered
              i.fa.fa-fw.mr-2(:class="item.icon")
              .py-1.flex-1 {{ item.label }}
              i.fa.fa-fw.fa-angle-right
</template>

<script>
export default {
  vuex: { auth: { state: ["usuario"], actions: ["fetchUsuario"] } },
  computed: {
    items() {
      return [
        {
          id: "userHome",
          label: "Minha conta",
          icon: "fa-address-card text-primary",
          action: () => this.$auth.home(),
        },
        {
          id: "userPassword",
          label: "Alterar senha",
          icon: "fa-key text-primary",
          action: () => this.$auth.password(),
        },
        {
          id: "about",
          label: "Sobre o sistema",
          icon: "fa-info-circle text-primary",
          action: () =>
            this.$route.name !== "app.about" &&
            this.$router.push({ name: "app.about" }),
        },
        {
          id: "signOut",
          label: "Sair",
          icon: "fa-power-off text-error",
          action: this.signOut,
        },
      ];
    },
  },
  methods: {
    async signOut() {
      const options = { title: "Confirmar", size: "sm" };
      const res = await this.$dialogs.confirm(
        "Deseja sair do Acesso Cidadão?",
        options
      );
      if (res.ok) {
        await this.$auth.signOut();
        this.$router.replace({ name: "welcome" });
      }
    },
  },
  created() {
    this.fetchUsuario();
  },
};
</script>

<style lang="stylus" scoped>
.navbar {
  border-bottom: solid 1px #ccc;
}

.img-logo {
  width: 40px;
}

ul.menu {
  min-width: 100%;
  width: 250px;
}

a {
  text-decoration: none;
  box-shadow: none;
}

.centered {
  align-items: center;
}
</style>
